import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Video, Film, GraduationCap } from 'lucide-react';
export function FilmsPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-347" data-mp="ry86bjb0dduw">
      <Header data-id="element-348" data-mp="nxoaqk632iav" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-349" data-mp="nwv37gzavoro">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-350" data-mp="6944f79xett">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-351" data-mp="4ob4u0ly3y2">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-352" data-mp="904afqk4tbb1" />
            Back to Home
          </a>

          <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-353" data-mp="4843vf9k3k5h">
            <div className="mb-12 flex justify-center" data-id="element-354" data-mp="46j85mbi9v61">
              <img src="https://cdn.magicpatterns.com/uploads/5psnYgvbA4E9mU4Q3CmWZP/Twice_Bourne_Ent._Logo_White-08.png" alt="TwiceBourne Entertainment Films Logo" className="max-w-md w-full h-auto" data-id="element-355" data-mp="3cmuthm6ket6m" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-356" data-mp="3hcrxjwi1yb21">
              TwiceBourne Entertainment Films LLC
            </h1>
            <p className="text-xl text-slate-300" data-id="element-357" data-mp="3m6czu0qohr71">
              Crafting compelling narratives that captivate audiences globally.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-358" data-mp="2tgnvpeio9b17">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-359" data-mp="2yefn87femv4v">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-360" data-mp="33g51dvxxbox6">
                <Video className="w-8 h-8" data-id="element-361" data-mp="intg5mm2ftnu" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-362" data-mp="in9zsac2ddbx">
                Film Production
              </h3>
              <p className="text-slate-300" data-id="element-363" data-mp="noh768aaoai2">
                Producers and sellers of high-quality movies, dedicated to
                cinematic storytelling.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-364" data-mp="2et27za7v8qte">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-365" data-mp="2opndrxrpm5ya">
                <Film className="w-8 h-8" data-id="element-366" data-mp="20x6s7d8rjvu8" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-367" data-mp="1w1hrh6l0c8wc">
                Film Acquisition
              </h3>
              <p className="text-slate-300" data-id="element-368" data-mp="29swb9fmqoe4g">
                Buying movies from independent producers to expand our diverse
                portfolio.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-369" data-mp="1h9r2vt325v7l">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-370" data-mp="134qru1okfkka">
                <GraduationCap className="w-8 h-8" data-id="element-371" data-mp="17xa1woo1nxkc" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-372" data-mp="t8dmu7nklka8">
                Cinematic Courses
              </h3>
              <p className="text-slate-300" data-id="element-373" data-mp="y7gu7yr0w2ld">
                Hosting of mini courses for cinematic enthusiasts to learn the
                art of filmmaking.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-374" data-mp="1qt9xe9g8dj8o" />
    </div>;
}